/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SlackCallbackRouteImport } from './routes/slack-callback'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as NotionCallbackRouteImport } from './routes/notion-callback'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as GoogleCallbackRouteImport } from './routes/google-callback'
import { Route as DiscordCallbackRouteImport } from './routes/discord-callback'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuthCallbackRouteImport } from './routes/auth-callback'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedProjectCreateOrJoinRouteImport } from './routes/_authenticated/project-create-or-join'
import { Route as AuthenticatedProjectIdIndexRouteImport } from './routes/_authenticated/$projectId/index'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackCallbackRoute = SlackCallbackRouteImport.update({
  id: '/slack-callback',
  path: '/slack-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NotionCallbackRoute = NotionCallbackRouteImport.update({
  id: '/notion-callback',
  path: '/notion-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const GoogleCallbackRoute = GoogleCallbackRouteImport.update({
  id: '/google-callback',
  path: '/google-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscordCallbackRoute = DiscordCallbackRouteImport.update({
  id: '/discord-callback',
  path: '/discord-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProjectCreateOrJoinRoute =
  AuthenticatedProjectCreateOrJoinRouteImport.update({
    id: '/project-create-or-join',
    path: '/project-create-or-join',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectIdIndexRoute =
  AuthenticatedProjectIdIndexRouteImport.update({
    id: '/$projectId/',
    path: '/$projectId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/change-password': typeof ChangePasswordRoute
  '/discord-callback': typeof DiscordCallbackRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/notion-callback': typeof NotionCallbackRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/slack-callback': typeof SlackCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/project-create-or-join': typeof AuthenticatedProjectCreateOrJoinRoute
  '/$projectId': typeof AuthenticatedProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/change-password': typeof ChangePasswordRoute
  '/discord-callback': typeof DiscordCallbackRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/notion-callback': typeof NotionCallbackRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/slack-callback': typeof SlackCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/project-create-or-join': typeof AuthenticatedProjectCreateOrJoinRoute
  '/$projectId': typeof AuthenticatedProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth-callback': typeof AuthCallbackRoute
  '/change-password': typeof ChangePasswordRoute
  '/discord-callback': typeof DiscordCallbackRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/notion-callback': typeof NotionCallbackRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/slack-callback': typeof SlackCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/project-create-or-join': typeof AuthenticatedProjectCreateOrJoinRoute
  '/_authenticated/$projectId/': typeof AuthenticatedProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-callback'
    | '/change-password'
    | '/discord-callback'
    | '/google-callback'
    | '/invite'
    | '/login'
    | '/notion-callback'
    | '/set-password'
    | '/signup'
    | '/slack-callback'
    | '/verify-email'
    | '/project-create-or-join'
    | '/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-callback'
    | '/change-password'
    | '/discord-callback'
    | '/google-callback'
    | '/invite'
    | '/login'
    | '/notion-callback'
    | '/set-password'
    | '/signup'
    | '/slack-callback'
    | '/verify-email'
    | '/project-create-or-join'
    | '/$projectId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth-callback'
    | '/change-password'
    | '/discord-callback'
    | '/google-callback'
    | '/invite'
    | '/login'
    | '/notion-callback'
    | '/set-password'
    | '/signup'
    | '/slack-callback'
    | '/verify-email'
    | '/_authenticated/project-create-or-join'
    | '/_authenticated/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  DiscordCallbackRoute: typeof DiscordCallbackRoute
  GoogleCallbackRoute: typeof GoogleCallbackRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  NotionCallbackRoute: typeof NotionCallbackRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignupRoute: typeof SignupRoute
  SlackCallbackRoute: typeof SlackCallbackRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slack-callback': {
      id: '/slack-callback'
      path: '/slack-callback'
      fullPath: '/slack-callback'
      preLoaderRoute: typeof SlackCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notion-callback': {
      id: '/notion-callback'
      path: '/notion-callback'
      fullPath: '/notion-callback'
      preLoaderRoute: typeof NotionCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/google-callback': {
      id: '/google-callback'
      path: '/google-callback'
      fullPath: '/google-callback'
      preLoaderRoute: typeof GoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discord-callback': {
      id: '/discord-callback'
      path: '/discord-callback'
      fullPath: '/discord-callback'
      preLoaderRoute: typeof DiscordCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-callback': {
      id: '/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/project-create-or-join': {
      id: '/_authenticated/project-create-or-join'
      path: '/project-create-or-join'
      fullPath: '/project-create-or-join'
      preLoaderRoute: typeof AuthenticatedProjectCreateOrJoinRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$projectId/': {
      id: '/_authenticated/$projectId/'
      path: '/$projectId'
      fullPath: '/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProjectCreateOrJoinRoute: typeof AuthenticatedProjectCreateOrJoinRoute
  AuthenticatedProjectIdIndexRoute: typeof AuthenticatedProjectIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProjectCreateOrJoinRoute: AuthenticatedProjectCreateOrJoinRoute,
  AuthenticatedProjectIdIndexRoute: AuthenticatedProjectIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  DiscordCallbackRoute: DiscordCallbackRoute,
  GoogleCallbackRoute: GoogleCallbackRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  NotionCallbackRoute: NotionCallbackRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignupRoute: SignupRoute,
  SlackCallbackRoute: SlackCallbackRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
